import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
const StatusDot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ status }) => {
        switch (status) {
            case "verified":
                return "#00BFB3";
            case "pending_verification":
                return "#FEC514";
            case "unverified":
                return "#BD271E";
        }
    }};
`;

const Status = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #343741;
`;

const VereficationStatus = ({ status }) => {
    const getStatusName = () => {
        switch (status) {
            case "verified":
                return <FormattedMessage id="verefication-status.verified" />;
            case "pending_verification":
                return <FormattedMessage id="verefication-status.pending" />;
            case "unverified":
                return <FormattedMessage id="verefication-status.unverified" />;
            default:
                return "Undefined";
        }
    };

    return (
        <Container>
            <StatusDot status={status} />
            <Status>{getStatusName(status)}</Status>
        </Container>
    );
};

export default VereficationStatus;
